import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {ContractNotValala, ContractNotValalaState}				from './interface';
import actions 								from './contractsNotValalaAction';


const initialState: ContractNotValalaState = {
	isLoad:    false,
	isLoadPut: false,
	data:      []
};

export const getContractsNotValalaApi = createAsyncThunk('contractNotValala/getContractsNotValalaApi', actions.getContractsNotValalaApi);
export const postContractNotValalaApi = createAsyncThunk('contractNotValala/postContractNotValalaApi', actions.postContractsNotValalaApi);
export const putContractNotValalaApi = createAsyncThunk('contractNotValala/putContractNotValalaApi', actions.putContractsNotValalaApi);

export const Reducer = createSlice({
	name:     'contractNotValala',
	initialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getContractsNotValalaApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getContractsNotValalaApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		// --- POST
		.addCase(postContractNotValalaApi.fulfilled, (state, action) => {
			if (action.payload)
				state.data.push(action.payload);
		})
		// --- PUT
		.addCase(putContractNotValalaApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putContractNotValalaApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: ContractNotValala[] = state.data.map((contract) => {
				if (contract && action.payload._id === contract._id)
					return {...contract, ...action.payload};
				return contract;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
